var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00003 1.33331C8.87551 1.33331 9.74242 1.50574 10.5513 1.84077C11.3601 2.1758 12.095 2.66686 12.7141 3.28592C13.3331 3.90498 13.8242 4.6399 14.1592 5.44874C14.4943 6.25758 14.6667 7.12449 14.6667 7.99997C14.6667 11.6819 11.6819 14.6667 8.00003 14.6667C4.31816 14.6667 1.33337 11.6819 1.33337 7.99997C1.33337 4.31809 4.31816 1.33331 8.00003 1.33331ZM8.66672 8.66666H7.33337C5.68291 8.66666 4.26594 9.66625 3.65478 11.0932C4.62178 12.4491 6.20766 13.3333 8.00003 13.3333C9.7924 13.3333 11.3783 12.4491 12.3453 11.0931C11.7342 9.66625 10.3172 8.66666 8.66672 8.66666ZM8.00003 3.33331C6.89547 3.33331 6.00003 4.22875 6.00003 5.33331C6.00003 6.43788 6.89547 7.33331 8.00003 7.33331C9.10459 7.33331 10 6.43788 10 5.33331C10 4.22875 9.10462 3.33331 8.00003 3.33331Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileBlack);
export default __webpack_public_path__ + "static/media/Profile_Black.e68ebfd70ad5db67ac74175c0a07aeab.svg";
export { ForwardRef as ReactComponent };